import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const ComingSoon = ({ 
  featureName, 
  description, 
  icon: Icon
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200"
          >
            <ArrowLeft size={20} />
            <span>Back to Home</span>
          </Link>
        </div>

        {/* Main Content */}
        <div className="text-center">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-24 h-24 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg">
              <Icon size={48} className="text-white" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {featureName}
          </h1>
          
          {/* Coming Soon Badge */}
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-400 to-red-500 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-lg mb-8">
            <Clock size={20} />
            <span>Coming Soon</span>
          </div>

          {/* Description */}
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed">
            {description}
          </p>

          {/* CTA to try working feature */}
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Meanwhile, try our Conceptual Estimate!</h3>
            <p className="text-gray-600 mb-6">
              Get started with our AI-powered conceptual cost estimation tool that's available now.
            </p>
            <Link 
              to="/conceptual-estimate"
              className="inline-flex items-center space-x-2 bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 text-lg"
            >
              <span>Try Conceptual Estimate</span>
              <ArrowLeft size={20} className="rotate-180" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
